
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import auth from '@/modules/Auth'
import backend from '@/modules/Backend'

export default {
  directives: {
    TransferDom
  },
  components: {
    Group,
    Cell,
    CellBox,
    XHeader,
    Confirm
  },
  data () {
    return {
      showConfirmUnlink: false,
      selectedUserId: this.$store.state.user.id
    }
  },
  methods: {
    selectUser (userId) {
      this.selectedUserId = userId
    },
    switchUser (userId) {
      auth.switch(userId)
    },
    unlink () {
      const linkId = this.$store.state.profile.links.find(link => link.user_id === this.selectedUserId).id
      this.$vux.loading.show({
        transition: '',
        text: '处理中...'
      })
      backend.unlink(this.$store.state.wuid, linkId).then(() => {
        this.$router.push('/logout')
      })
    },
    displayName (user) {
      return `${user.data.local_name}  ${user.username}`
    },
    back () {
      this.$router.push('settings')
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    selectedUser () {
      const self = this
      return this.profile.users.find(
        (user) => user.id === self.selectedUserId)
    },
    otherUsers () {
      const self = this
      return this.profile.users.filter(
        (user) => user.id !== self.selectedUserId)
    },
    hasMoreUsers () {
      return this.otherUsers.length > 0
    }
  },
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/components/Links.vue